export default __webpack_public_path__ + "static/media/danta_white_female.42b28ba4.png";